package ld.scenes;
import pixi.core.renderers.SystemRenderer;
import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.extras.BitmapText;
import pixi.extras.AnimatedSprite;

import stocking.ColoredBitmapText;
import stocking.SceneManager;

import tweenx909.TweenX;
import tweenxcore.color.RgbColor;
import tweenxcore.Tools.Easing;

import ld.NotificationWindow;
import ld.scenes.EditorScene;
import stocking.AudioManager;



import stocking.Scene;

class MenuScene extends Scene
{
	var bgPosition = { x: 0., y: 0.};
	var containerScene : Container = new Container();
	var containerBG : Container = new Container();

	public function new( renderer : SystemRenderer, stage : Container )
	{
		super( renderer, stage );
	}

    public override function preload()
    {
		loaderImages = [
			{ filename: "assets/gemu_bg.png"},
			{ filename: "assets/logo.png"},
			{ filename: "assets/eventflag_active.png"},
			{ filename: "assets/eventflag_inactive.png"},
			{ filename: "assets/bg_tiled.png"},
			{ filename: "assets/day_container.png"},
			{ filename: "assets/choice_container.png"},
		];

		loaderFonts = [
			"assets/khdot16.fnt",
			"assets/khdot12.fnt",
		];

		loaderSfx = [
			"assets/hover.ogg",
			"assets/fail.ogg",
			"assets/notif.ogg",
			"assets/succes.ogg",
			"assets/decline.ogg",
			"assets/accept.ogg",
		];
		super.preload();
    }

	public override function enter()
	{
		super.enter();

		container.addChild(containerBG);
		container.addChild(containerScene);
		
		// Fill BG container
		for( x in 0 ... cast 1 + 320 / 64 )
		{
			for( y in 0 ... cast 1 + 224 / 64)
			{
				var s = new Sprite( Texture.fromImage( "assets/bg_tiled.png" ) );
				s.position.x = 64 * x;
				s.position.y = 64 * y;
				containerBG.addChild( s );
			}
		}

		// Logo
		var logo = new Sprite( Texture.fromImage("assets/logo.png"));
		containerScene.addChild(logo);
		logo.y = -224;

		TweenX.to( logo, { y: -10}).ease( Easing.bounceOut ).time(3);

		// copyright
		/*
		var txt = new BitmapText("1993 Waifu Works", { font: "12px khdot12" } );
		containerScene.addChild(txt);
		txt.x = 220;
		txt.y=0;
		txt.alpha=0;
		containerScene.addChild(txt);

		TweenX.to( txt, { alpha: 1}).time(0.5);
		*/
	
		// New game btn
		var btn = MakeButton("New Game");
		btn.click = btn.tap = function( event : pixi.interaction.InteractionEvent ) { 
			AudioManager.instance.play("succes");
			TweenX.to( container, {alpha: 0}).time(0.5).onFinish(function(){
				
				exited = true;
				this.stage.removeChild( this.container );
				SceneManager.instance.transitionToScene(new GameScene(renderer, stage));
			});
		};

		var btnStart =  10;
		var btnSpace = 103;
		var btnY = 185;

		
	
		btn.x = 320;
		btn.y = btnY;
		TweenX.to( btn, { x: btnStart } ).delay(0.5).time(0.2);

		containerScene.addChild( btn );

		// Editor btn
		var btn = MakeButton("Edit Data");
		btn.click = btn.tap = function( event : pixi.interaction.InteractionEvent ) { 
			AudioManager.instance.play("accept");
			TweenX.to( container, {alpha: 0}).time(0.5).onFinish(function(){
				exited = true;
				this.stage.removeChild( this.container );
				SceneManager.instance.transitionToScene(new EditorScene(renderer, stage));
			});
		};

		btn.x = 320;
		btn.y = btnY;
		TweenX.to( btn, { x: btnStart + btnSpace } ).delay(0.5 + 0.1).time(0.2);


		containerScene.addChild( btn );

		// Editor btn
		var btn = MakeButton("Reset Data");
		btn.click = btn.tap = function( event : pixi.interaction.InteractionEvent ) { 
		AudioManager.instance.play("accept");
				var storage = js.Browser.getLocalStorage();
				if( storage != null )
				{
					storage.clear();
				}

		
		};

		btn.x = 320;
		btn.y = btnY;
		TweenX.to( btn, { x: btnStart + btnSpace * 2 } ).delay(0.5 + 0.2).time(0.2);

		containerScene.addChild( btn );

		container.alpha = 0;

		TweenX.to( container, { alpha: 1 } ).time(1);
		
		
	}

	public override function tick( delta : Float )
	{
		bgPosition.y += 0.5;
		bgPosition.x += 1;

		bgPosition.x = bgPosition.x % 64;
		bgPosition.y = bgPosition.y % 64;

		containerBG.position.x = -Math.floor(bgPosition.x);
		containerBG.position.y = -Math.floor(bgPosition.y);
	}

	public function MakeButton( text : String )
	{
		var choiceContainer = new Container();
		var button = new Sprite( Texture.fromImage( "assets/choice_container.png" ) );
		choiceContainer.addChild(button);

		var shadowText = new BitmapText( text, { font: "16px khdot16", align: BitmapTextAlign.CENTER } );
		shadowText.position.y = 8;
		shadowText.anchor.x = 0.5;
		shadowText.position.x = 95/2 + 1;
		shadowText.tint = 0x0;
		//optionText
		shadowText.align = BitmapTextAlign.CENTER;
		choiceContainer.addChild(shadowText);
		
		var optionText = new BitmapText( text, { font: "16px khdot16", align: BitmapTextAlign.CENTER } );
		optionText.position.y = 7;
		optionText.anchor.x = 0.5;
		optionText.position.x = 95/2;
		optionText.tint = 0xaaaaaa;
		//optionText
		optionText.align = BitmapTextAlign.CENTER;
		choiceContainer.addChild(optionText);

		choiceContainer.mouseover = function( event : pixi.interaction.InteractionEvent ) { 
			AudioManager.instance.play("hover");
			TweenX.to( optionText, {tint: RgbColor.of( 0xffffff ) } ).time(0.2);
		};
		choiceContainer.mouseout = function( event : pixi.interaction.InteractionEvent ) { 
			TweenX.to( optionText, {tint: RgbColor.of( 0xaaaaaa ) } ).time(0.2);
		};

		choiceContainer.interactive = true;

		return choiceContainer;
	}

	public override function exit()
	{
		//this.stage.removeChild( this.container );
		//exited = true;
	}
}
